import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import './ProtectedRoute.css';

export default function ProtectedRoute({ children, roles, requireFinance = false }) {
  const { user, isAuthenticated, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="route-guard-loading" role="status" aria-live="polite">
        Carregando sessão...
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/entrar" replace state={{ from: location.pathname }} />;
  }

  if (roles?.length && !roles.includes(user?.role)) {
    return <Navigate to="/conta" replace />;
  }

  if (requireFinance && !user?.canAccessFinance) {
    return <Navigate to="/conta" replace />;
  }

  return children;
}
